import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/site/Body/Body.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/App.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/common/Svg/Svg.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/common/Button/Button.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/site/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/site/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/site/MobileMenu/MobileMenu.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/site/Page/Page.module.css");
